import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import { Vector, HashSet } from 'prelude-ts';

import { RuleExecutor } from '../Rule';
import Formula from '../formula/Formula';
import FormulaBox from './FormulaBox';
import Statement from '../Statement';
import { FormulaPositionMonitor, FormulaPositions } from './Subgoal';

import styles from '../styles/PlayArea.module.css';

interface Props {
  subgoal: Statement;
  formulae: Vector<Formula>;
  executor: RuleExecutor;

  draggingEnabled: boolean;
  tooltip: boolean;
  formulaPositionMonitor: FormulaPositionMonitor;
  positions: FormulaPositions;
  splits: { above: HashSet<Formula['id']>; below: HashSet<Formula['id']> };
}

class ResourseBox extends Component<Props> {
  render() {
    const id = 'resource-box-' + this.props.subgoal.id;

    return (
      <Paper id={id} className={styles.resourceBox}>
        {this.props.formulae.map(formula => (
          <div key={formula.id} className={styles.item}>
            <FormulaBox
              formula={formula}
              subgoal={this.props.subgoal}
              executor={this.props.executor}
              draggingEnabled={this.props.draggingEnabled}
              tooltip={this.props.tooltip}
              dragId={id}
              positionMonitor={this.props.formulaPositionMonitor}
              position={this.props.positions.get(formula.id).getOrUndefined()}
              split={
                this.props.splits.above.contains(formula.id)
                  ? 'above'
                  : this.props.splits.below.contains(formula.id)
                  ? 'below'
                  : undefined
              }
            />
          </div>
        ))}
      </Paper>
    );
  }
}

export default ResourseBox;
